import React, { Component } from 'react';
import { Select } from 'antd';

const Option = Select.Option;

class TypeMultiply extends Component {
	constructor(props) {
		super(props);
		this.data = null;
	}
	getData(){
		return null;
	}
	render() {
		let data = this.getData();
		
		if (!data) {
			return null
		}

		const { title, onChange, className } = this.props;
		return <span className={className}>
			<Select placeholder={title}
			        mode="tags"
			        size='default'
			        style={{ width: '100%' }}
			        onChange={onChange}>
					{data.map((o, i) =>
						<Option key={i} value={data[i]} title={data[i]}>
							{data[i]}
						</Option>)
					}
		    </Select>
	  </span>;
	}
}

export default TypeMultiply;




// WEBPACK FOOTER //
// ./src/components/AnswerTypeMultiply/TypeMultiply.js